import Haiku from './forms/haiku'
import Limerick from './forms/limerick'
import OdeHoration from './forms/ode-horation'
import Pallindrome from './forms/pallindrome'
import SonnetShakespearean from './forms/sonnet-shakespearean'


export default [
    Haiku,
    Limerick,
    OdeHoration,
    Pallindrome,
    SonnetShakespearean
]